import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { OrderDetailsDirective } from 'src/app/inventory/directives/order-details.directive';
import { IOrderSaleReturnDetailsData } from 'src/app/inventory/interfaces/order-sale-return-details-data.interface';
import { NavigatedFromPipe } from 'src/app/shared/pipes/navigated-from/navigated-from.pipe';
import { PinService } from 'src/app/shared/services/pin.service';
import { GetSaleToProviderDetails } from 'src/app/shared/states/orders/orders.actions';
import { OrdersState } from 'src/app/shared/states/orders/orders.state';
import { OrdersService } from '../../receive-edi/orders.service';
import { IOptionItem } from 'src/app/shared/interfaces/option-item.interface';
import { OrderTypeEnum } from 'src/app/shared/interfaces/OrderTypeEnum';
import { getFileTypes } from 'src/app/inventory/interfaces/file-types-list';
import { FileService } from 'src/app/shared/services/file-service';
import { PdfSignatureService } from 'src/app/shared/services/pdf-signature-service';
import { CSOSRequiredValidator } from 'src/app/shared/validators/CSOS.validator';

@UntilDestroy()
@Component({
  selector: 'app-sale-to-provider-details',
  templateUrl: './sale-to-provider-details.component.html',
  styleUrls: ['./sale-to-provider-details.component.scss', '../../../inventory.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SaleToProviderDetailsComponent extends OrderDetailsDirective {
  @Select(OrdersState.orderSaleOrReturnDetailsData) orderWithDetails$: Observable<IOrderSaleReturnDetailsData | undefined>;
  orderWithDetails: IOrderSaleReturnDetailsData;

  fileTypes: IOptionItem[] = getFileTypes(OrderTypeEnum.SaleToProvider);
  /**
   *
   */
  constructor( 
    protected router: Router,
    protected store: Store,
    protected orderService: OrdersService,
    protected pinService: PinService,
    private route: ActivatedRoute,
    private navigatedFromPipe: NavigatedFromPipe,
    protected cdr: ChangeDetectorRef,
    protected fileService: FileService,
    protected pdfSignatureService: PdfSignatureService, 
  ) {
    super(router, store, orderService, pinService, cdr, fileService, pdfSignatureService);
    const id = this.route.snapshot.params?.id;
    this.store.dispatch(new GetSaleToProviderDetails(id));

    this.setUpTable();

    this.pinService.validatePin$
    .pipe(untilDestroyed(this))
    .subscribe(async res => {
      if (res?.dialogId === this.saveAttachmentPinChannelName && res?.success) {
        const order = this.store.selectSnapshot(OrdersState.orderSaleOrReturnDetailsData);
        await this.signAndSendUpdatedAttachmentsToApi(order.id, res.pin, res.response?.user, order.createDate)
        .then(() => this.orderWithDetails = {...this.orderWithDetails, csos: this.form.getRawValue()?.csos});
        this.pinService.closeDialog();
      }
    })

      this.orderWithDetails$
      .pipe(untilDestroyed(this))
      .subscribe(orderWithDetails => {
        this.orderWithDetails = orderWithDetails;
        const csos = this.form.get('csos');
        csos.patchValue(orderWithDetails?.csos);
        csos.setValidators(CSOSRequiredValidator.bind(this, this.orderWithDetails?.orderLines));
      });
  }

  navigateBack() {
    const navigatedFrom = this.navigatedFromPipe.transform(this.navigationState, 'Sales to Providers', '/inventory/sales-to-providers-history')?.link;
    this.router.navigate([navigatedFrom], {state: {
      isNavigatedBack: true
    }});
  }
}
